/**
 * Student Sharing JS
 *
 * @package LifterLMS_Social_Learning/Scripts
 *
 * @since 1.0.0
 * @version 1.6.0
 */

( function( $ ){

	/**
	 * Story-related interactions
	 *
	 * @since 1.0.0
	 */
	var StoryInteractions = function() {

		/**
		 * Clear an error message
		 *
		 * @since 1.0.0
		 *
		 * @param {object} $error The jQuery element for an error message to clean.
		 * @return {void}
		 */
		function clear_error( $error ) {
			$error.html( '' );
		}

		/**
		 * Initiliaze LLMS Donuts on stories
		 *
		 * @since 1.0.0
		 *
		 * @return {void}
		 */
		function donuts() {

			$( '.llms-sl-card--story-pass .llms-donut' ).each( function() {
				LLMS.Donut( $( this ) );
			} );

		}


		/**
		 * Initiliaze image modals on stories
		 *
		 * @since 2.0.0
		 *
		 * @return {void}
		 */
		function images() {

			var id     = 'llms-sl-story-image-modal',
				$modal = $( '#' + id );

			if ( ! $modal.length ) {
				$modal = $( '<div class="llms-sl-story-image-modal" id="' + id + '" />' );
				$( 'body' ).append( $modal );
			}

			$modal.iziModal( {
				width: '90%',
				headerColor: '#3a3a3a',
				overlayColor: 'rgba( 0, 0, 0, 0.6 )',
				transitionIn: 'fadeInDown',
				transitionOut: 'fadeOutDown',
				onOpening: function( modal ) {
					let image_id = $modal.attr( 'data-image-id' );
					$container = $( document ).find( '[data-image-id="' + image_id + '"]' );
					modal.setContent( $container.html() );
					modal.setTitle( LLMS.l10n.translate( 'Image' ) );
				}
			} );

			$( '.llms-sl-story-image-wrapper .llms-sl-modal-trigger' ).on( 'click', function( event ) {
				event.preventDefault();

				$modal = $( '#' + id );
				$modal.attr( 'data-image-id', $( event.target ).closest( '.llms-sl-story-image-link' ).attr( 'data-image-id' ) );
				$modal.iziModal( 'open' );
			} );

		}

		/**
		 * Show an error message
		 *
		 * @since 1.0.0
		 *
		 * @param {object} $error The jQuery element for an error message to show.
		 * @param {string} msg    Error message text/string.
		 * @return {void}
		 */
		function show_error( $error, msg ) {
			$error.html( LLMS.l10n.translate( 'Error' ) + ': ' + msg );
		};

		/**
		 * General method for posting story related data to the server via ajax
		 *
		 * Automatically starts a spinner on a parent element.
		 *
		 * @since 1.0.0
		 *
		 * @param {object}   data    Data to post to the server.
		 * @param {object}   $parent The jQuery element for the parent node.
		 * @param {function} cb      Callback function.
		 * @param {string}   size    Optional spinner size (small).
		 * @return {void}
		 */
		function post( data, $parent, cb, size ) {

			LLMS.Ajax.call( {
				data: data,
				beforeSend: function() {

					LLMS.Spinner.start( $parent, size );

				},
				error: function( xhr, status, error ) {

					var msg = '';

					if ( 'object' === typeof error && error.message ) {
						msg = error.message;
					} else {
						msg = error;
					}

					cb( {
						message: msg,
						success: false,
						data: {
							status: status,
							error: error,
						}
					} );

					console.error( status, error );

					LLMS.Spinner.stop( $parent );

				},

				success: function( r ) {

					LLMS.Spinner.stop( $parent );
					cb( r );

				}

			} );

		};

		/**
		 * Handle filtering via select element on instructor's filter card.
		 *
		 * @since 1.1.0
		 */
		var Filtering = function() {

			/**
			 * Bind dom events.
			 *
			 * @since 1.1.0
			 * @since 1.6.0 Use `window.llms.ajax_nonce` in place of `wp_ajax_data.nonce`.
			 *              Allow clearing selection: reloads the timeline.
			 *
			 * @return {void}
			 */
			function bind() {

				$el.llmsSelect2( {
					allowClear: true,
					ajax: {
						dataType: 'JSON',
						delay: 250,
						method: 'POST',
						url: window.llms.ajaxurl,
						data: function( params ) {
							return {
								action: 'llms_sl_filter_posts',
								term: params.term,
								page: params.page,
								_ajax_nonce: window.llms.ajax_nonce,
							};
						},
						error: function( xhr, status, error ) {
							console.log( status, error );
						},
					},
					dropdownParent: $( '#llms-sl-card--timeline-filters-instructor' ),
					placeholder: LLMS.l10n.translate( 'Search by title...' ),
					width: '100%',
				} ).on( 'select2:select', function( e ) {
					window.location = e.params.data.url;
				} ).on( 'select2:unselect', function() {
					window.location = $el.data( 'timeline-url' );
				});

			};

			var $el = $( '#llms-sl-instructor-filter-post' );

			if ( $el.length ) {

				// Bind dom events.
				bind();

			}

		};

		/**
		 * User interactions for managing (editing and deleting) existing stories
		 *
		 * @since 1.0.0
		 * @since 1.2.1 Unknown.
		 */
		var Managing = function() {

			var	cached_html;

			/**
			 * Bind DOM events
			 *
			 * @since 1.0.0
			 * @since 1.2.1 Unknown.
			 * @since 1.3.0 Changed parent's selector from `'.llms-sl-timeline-main'` to `'.llms-sl-timeline'`
			 *              so to target cards in profile's tab content too.
			 *
			 * @return {void}
			 */
			function bind() {

				var $parent = $( '.llms-sl-timeline-main, .llms-sl-profile-main' );

				let hoverTimer;

				$parent.on( 'mouseover', '.llms-sl-has-context-menu', function() {
					$( this ).find( '.llms-sl-context-menu' ).addClass( 'llms-sl-menu-open' );
					clearTimeout( hoverTimer );
				} );

				$parent.on( 'mouseout', '.llms-sl-has-context-menu', function() {
					$menu = $( this ).find( '.llms-sl-context-menu' );
					hoverTimer = setTimeout( function() {
						$menu.removeClass( 'llms-sl-menu-open' );
					}, 1000 );
				} );

				$parent.on( 'click', '.llms-sl-has-context-menu a', function( e ) {
					$btn = $( this );
					$menu = $( this ).siblings( '.llms-sl-context-menu' );

					// Toggle expanded state of the context menu.
					if ( $btn.attr( 'aria-expanded' ) === 'true' ) {
						$btn.attr( 'aria-expanded', 'false' );
						$menu.removeClass( 'llms-sl-menu-open' );
					} else {
						$btn.attr( 'aria-expanded', 'true' );
						$menu.addClass( 'llms-sl-menu-open' );
					}
					e.preventDefault();
					return false;
				} );

				// Make the story editable.
				$parent.on( 'click', '.llms-sl-card--story .llms-sl-context-menu .edit-story', function( e ) {

					e.preventDefault();
					var $btn = $( this ),
					$story   = $btn.closest( '.llms-sl-card--story' ),
					$text    = $story.find( '.llms-sl-card-text' );

					$text.hide();
					$story.find( '.llms-sl-edit-story' ).show();
					$story.find( '.llms-sl-edit-story textarea' ).focus();

					$story.find('.llms-sl-card-action.manage-card' ).attr( 'aria-expanded', 'false' );
					$story.find( '.llms-sl-context-menu' ).removeClass( 'llms-sl-menu-open' );
				} );

				// Cancel a story edit.
				$parent.on( 'click', '.llms-sl-card--story button.llms-sl-edit-story-cancel', function( e ) {

					e.preventDefault();
					var $btn = $( this ),
					$story   = $btn.closest( '.llms-sl-card--story' ),
					$main    = $story.find( '.llms-sl-card-main' ),
					$content    = $main.find( '.llms-sl-card-text' );

					$main.find( '.llms-sl-edit-story' ).hide();
					$content.show();

				} );

				$parent.on( 'submit', 'form.llms-sl-edit-story', function( e ) {

					e.preventDefault();

					var $btn = $( this ),
					$story   = $btn.closest( '.llms-sl-card--story' ),
					$main    = $story.find( '.llms-sl-card-main' ),
					$content    = $main.find( '.llms-sl-card-text' ),
					$form = $( this ),
					$error   = $main.find( '.llms-sl-card-error' ),
					story_id = $story.attr( 'data-story-id' ),
					data     = {
						action: 'llms_sl_story_edit',
						story_id: story_id,
						nonce: $( '#llms-sl-edit-story-nonce-' + story_id ).val(),
						content: $form.find( '#llms-sl-edit-story-' + story_id ).val(),
					};

					clear_error( $error );
					post( data, $main, function( r ) {

						if ( ! r ) {

							show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );

						} else if ( r && ! r.success ) {

							show_error( $error, r.message );

						} else if ( r.data && r.data.html ) {

							$form.hide();
							$content.html( r.data.html );
							$content.show();

						}

					} );

				} );

				// Delete a story.
				$parent.on( 'click', '.llms-sl-card--story .llms-sl-context-menu .delete-story', function( e ) {

					e.preventDefault();
					if ( window.confirm( LLMS.l10n.translate( 'Are you sure you want to delete this story? This action cannot be undone.' ) ) ) {

						var $story = $( this ).closest( '.llms-sl-card--story' ),
						data       = {
							action: 'llms_sl_story_delete',
							story_id: $story.attr( 'data-story-id' ),
						};

						post( data, $story, function( r ) {

							if ( ! r ) {

								alert( LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );

							} else if ( r && ! r.success ) {

								alert( r.message );

							} else {

								$story.fadeOut( 200 );

							}

						} );

					}

				} );

			};

			// Bind dom events.
			bind();

		};

		/**
		 * Paging related story interactions
		 *
		 * Autoloads stories when scrolling on timelines.
		 *
		 * @since 1.0.0
		 */
		var Paging = function() {

			var load_interval = 14,
			next_load_i       = 0,
			loading           = false,
			next_offset;

			/**
			 * Bind dom events
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function bind() {

				set_next_load_element();

				$( window ).on( 'scroll', function() {
					if ( ! loading && $( window ).scrollTop() >= next_offset ) {
						$( '#llms-sl-timeline-load-more' ).trigger( 'click' );
					}
				} );

				$( '.llms-sl' ).on( 'click', '#llms-sl-timeline-load-more', function() {

					loading = true;

					var $btn = $( this ),
					data     = {
						action: 'llms_sl_timeline_load_more',
						args: JSON.parse( $btn.attr( 'data-args' ) )
					};

					data.args.page++;

					post( data, $btn, function( r ) {

						if ( ! r ) {
							show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );
						} else if ( r && ! r.success ) {
							show_error( $error, r.message );
						} else if ( r.data && r.data.html ) {

							loading = false;

							var $stories = $( r.data.html ),
							r            = new Replying( $stories.find( 'form.llms-sl-story-reply' ) );

							$btn.hide();
							$btn.parent().append( $stories );
							donuts();
							images();
							$btn.remove();

							set_next_load_element();

						}

					}, 'small' );

				} );

			};

			/**
			 * Setup the next load element
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function set_next_load_element() {

				next_load_i = next_load_i + load_interval;

				var $el = $( '.llms-sl-timeline .llms-sl-card--story' ).eq( next_load_i );

				if ( $el.length ) {
					next_offset = $el.offset().top;
				}

			}

			bind();

		};

		/**
		 * Interactions related to posting replies to stories
		 *
		 * @param {object} $form The jQuery element of the reply form.
		 *
		 * @since 1.0.0
		 */
		var Replying = function( $form ) {
			var $image_modal = $form.find( '.llms-sl-story-reply-upload-modal' );

			$image_modal.iziModal();

			var $card       = $form.closest( '.llms-sl-card--story' ),
				story_id   = $card.attr( 'data-story-id' ),
				$img_upload_btn = $form.find( '.upload-image-to-comment' ),
				$img_remove_btn = $form.find( '.llms-sl-remove-btn' ),
				$attachments = $form.find( '.llms-sl-attachments' ),
				$error = $form.siblings( '.llms-sl-card-error' ),
				$uploader_zone = $( '#llms-sl-post-uploader-zone-' + story_id ),
				$upload_image_input = $uploader_zone.find( 'input[type="file"]' ),
				image_upload_nonce = $( '#llms-sl-new-share-image-nonce' ).val();

			/**
			 * Bind DOM events
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function bind() {

				$form.on( 'submit', function( e ) {
					e.preventDefault();

					if ( ! get_content() ) {
						return;
					}

					share();
				} );

				$img_upload_btn.on( 'click', function( e ) {
					e.preventDefault();
					$image_modal.iziModal( 'open' );
				} );

				$img_remove_btn.on( 'click', function( e ) {
					e.preventDefault();

					LLMS.Spinner.start( $form );

					var data = {
						action: 'llms_sl_remove_post_image',
						nonce: $( '#llms-sl-new-share-image-nonce' ).val(),
						img_id: $attachments.attr( 'data-image-id' ),
					};

					clear_error( $error );
					post( data, $card, function( r ) {

						if ( ! r ) {
							show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );
						} else if ( r && ! r.success ) {
							show_error( $error, r.message );
						} else {
							LLMS.Spinner.stop( $form );
							reset_uploading_image();
						}

					} );
				} );

				$uploader_zone.on( 'dragover', function() {
					$( this ).addClass( 'dragover' );
				} ).on( 'dragout', function() {
					$( this ).removeClass( 'dragover' );
				} ).on( 'drop', function( jqEvent ) {
					jqEvent.preventDefault();

					upload( jqEvent.originalEvent.dataTransfer.files[ 0 ] );
				} );

				$upload_image_input.on( 'change', function( jqEvent ) {
					upload( jqEvent.target.files[ 0 ] );
				} );
			};

			function reset_uploading_image() {
				$attachments.find( 'img' ).remove();
				$attachments.attr( 'data-image-id', '' );
				$attachments.hide();
				$img_upload_btn.css( 'visibility', 'visible' );
			}

			/**
			 * Upload share image via AJAX.
			 *
			 * @since 2.0.0
			 *
			 * @param {File} file JS DOM file transfer object.
			 * @return void
			 */
			function upload( file ) {
				var data = new FormData();

				// Prevent IE from making a 2nd request after the `#llms-sl-post-upload-image` value is blanked.
				if ( ! file ) {
					return;
				}

				data.append( 'action', 'llms_sl_upload_post_image' );
				data.append( 'image', file );
				data.append( 'nonce', image_upload_nonce );
				// Flag this for the media protector.
				data.append( 'llms', '1' );

				make_upload_request( data );

				// Reset upload image input element value so that the image can be replaced by a file with the same name.
				$upload_image_input.val( '' );
			}

			/**
			 * Makes an ajax request and provides error and success handlers.
			 *
			 * @since 1.6.0
			 *
			 * @param {FormData} data The data to send.
			 * @param {string}   type The image type, 'avatar'|'cover'.
			 * @return void
			 */
			function make_upload_request( data  ) {

				var spinnerParent = 'opened' === $image_modal.iziModal( 'getState' ) ? $image_modal : $form;

				LLMS.Ajax.call( {
					data: data,
					contentType: false,
					processData: false,
					beforeSend: function() {

						spinnerParent.find( '.llms-sl-error' ).remove();
						LLMS.Spinner.start( spinnerParent );

					},
					error: function( xhr, status, error ) {

						var msg = error;

						if ( 'object' === typeof error && error.message ) {
							msg = error.message;
						}
						$uploader_zone.append( '<p class="llms-sl-error">' + msg + '</p>' );

						LLMS.Spinner.stop( spinnerParent );

					},
					success: function( r ) {

						LLMS.Spinner.stop( spinnerParent );
						if ( r && r.success ) {
							$attachments.find( 'img' ).remove();
							$attachments.attr( 'data-image-id', r.data.id );
							$attachments.append( r.data.image );

							$image_modal.iziModal( 'close' );
							$img_upload_btn.css( 'visibility', 'hidden' );
							$attachments.show();
						} else {
							$uploader_zone.append( '<p class="llms-sl-error">' + r.message + '</p>' );
						}

					}

				} );

			}

			/**
			 * Add the HTML for a new reply after it's been saved via AJAX
			 *
			 * @since 1.0.0
			 *
			 * @param {object} $card The jQuery element of the story card to add the reply to.
			 * @param {string} html  Html of the reply.
			 */
			function add_reply_html( $card, html ) {

				$card.find( '.llms-sl-story-replies' ).append( html );

			};

			/**
			 * Retrieve the content of a reply from the reply text field element
			 *
			 * @since 1.0.0
			 *
			 * @return {string}
			 */
			function get_content() {
				return $form.find( '.llms-sl-story-reply-comment' ).val();
			};

			/**
			 * Save a story to the DB via ajax
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function share( ) {

				var $error      = $card.find( '.llms-sl-card-footer .llms-sl-card-error' );

				var data = {
					action: 'llms_sl_story_reply',
					story_id: story_id,
					nonce: $( '#llms-sl-reply-nonce-' + story_id ).val(),
					content: get_content(),
					img_id: $attachments.attr( 'data-image-id' ),
				};

				clear_error( $error );
				post( data, $form, function( r ) {

					if ( ! r ) {
						show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );
					} else if ( r && ! r.success ) {
						show_error( $error, r.message );
					} else if ( r.data && r.data.html ) {

						var $text = $form.find( '.llms-sl-story-reply-comment' );
						$text.parent().attr( 'data-replicated-value', '' );
						$text.val( '' );
						reset_uploading_image();

						add_reply_html( $card, r.data.html );

					}

				}, 'small' );

			};

			bind();

		};

		/**
		 * Interactions for sharing a new story
		 *
		 * @since 1.0.0
		 */
		var Sharing = function() {
			var $modal = $( '#llms-sl-post-upload-modal' );

			$modal.iziModal();

			var $card = $( '#llms-sl-card--new-share' ),
				$form = $('.llms-sl-card--new-share form'),
			$btn      = $( '#llms-sl-new-share-submit' ),
			$attachments = $( '#llms-sl-new-share-attachments' ),
			$img_upload_btn = $( '#llms-sl-new-share-image-upload' ),
			$uploader_zone = $( '#llms-sl-post-uploader-zone' ),
			$uploader_image_input = $( '#llms-sl-post-upload-image' ),
			$img_remove_btn = $card.find('.llms-sl-remove-btn'),
			$content  = $( '#llms-sl-new-share-content' ),
			$error    = $card.find( '.llms-sl-card-error' ),
			image_upload_nonce = $( '#llms-sl-new-share-image-nonce' ).val();

			/**
			 * Bind DOM events
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function bind() {
				$form.on( 'submit', function( e ) {
					e.preventDefault();

					if ( ! get_content() ) {
						return;
					}

					share();
				} );

				$img_upload_btn.on( 'click', function( e ) {
					e.preventDefault();
					$modal.iziModal( 'open' );
				} );

				$img_remove_btn.on( 'click', function( e ) {
					e.preventDefault();

					LLMS.Spinner.start( $card );

					var data = {
						action: 'llms_sl_remove_post_image',
						nonce: $( '#llms-sl-new-share-image-nonce' ).val(),
						img_id: $attachments.attr( 'data-image-id' ),
					};

					clear_error( $error );
					post( data, $card, function( r ) {

						if ( ! r ) {
							show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );
						} else if ( r && ! r.success ) {
							show_error( $error, r.message );
						} else {
							LLMS.Spinner.stop( $card );
							$attachments.find( 'img' ).remove();
							$attachments.hide();
							$img_upload_btn.css( 'visibility', 'visible' );
						}

					} );

				} );

				$uploader_zone.on( 'dragover', function() {
					$( this ).addClass( 'dragover' );
				} ).on( 'dragout', function() {
					$( this ).removeClass( 'dragover' );
				} ).on( 'drop', function( jqEvent ) {
					jqEvent.preventDefault();

					upload( jqEvent.originalEvent.dataTransfer.files[ 0 ] );
				} );

				$uploader_image_input.on( 'change', function( jqEvent ) {
					upload( jqEvent.target.files[ 0 ] );
				} );

			};

			/**
			 * Upload share image via AJAX.
			 *
			 * @since 2.0.0
			 *
			 * @param {File} file JS DOM file transfer object.
			 * @return void
			 */
			function upload( file ) {

				var data = new FormData();

				// Prevent IE from making a 2nd request after the `#llms-sl-post-upload-image` value is blanked.
				if ( ! file ) {
					return;
				}

				data.append( 'action', 'llms_sl_upload_post_image' );
				data.append( 'image', file );
				data.append( 'nonce', image_upload_nonce );
				// Flag this for the media protector.
				data.append( 'llms', '1' );

				make_upload_request( data );

				// Reset upload image input element value so that the image can be replaced by a file with the same name.
				$uploader_image_input.val( '' );
			}

			/**
			 * Makes an ajax request and provides error and success handlers.
			 *
			 * @since 1.6.0
			 *
			 * @param {FormData} data The data to send.
			 * @param {string}   type The image type, 'avatar'|'cover'.
			 * @return void
			 */
			function make_upload_request( data  ) {

				var spinnerParent = 'opened' === $modal.iziModal( 'getState' ) ? $modal : $form;

				LLMS.Ajax.call( {
					data: data,
					contentType: false,
					processData: false,
					beforeSend: function() {

						spinnerParent.find( '.llms-sl-error' ).remove();
						LLMS.Spinner.start( spinnerParent );

					},
					error: function( xhr, status, error ) {

						var msg = error;

						if ( 'object' === typeof error && error.message ) {
							msg = error.message;
						}
						$uploader_zone.append( '<p class="llms-sl-error">' + msg + '</p>' );

						LLMS.Spinner.stop( spinnerParent );

					},
					success: function( r ) {

						LLMS.Spinner.stop( spinnerParent );
						if ( r && r.success ) {
							$attachments.find( 'img' ).remove();
							$attachments.attr( 'data-image-id', r.data.id );
							$attachments.append( r.data.image );

							$modal.iziModal( 'close' );
							$img_upload_btn.css( 'visibility', 'hidden' );
							$attachments.show();
						} else {
							$uploader_zone.append( '<p class="llms-sl-error">' + r.message + '</p>' );
						}

					}

				} );

			}

			/**
			 * Retrieve the share content
			 *
			 * @since 1.0.0
			 *
			 * @return {string}
			 */
			function get_content() {
				return $content.val();
			};

			/**
			 * Share a new story via AJAX
			 *
			 * @since 1.0.0
			 *
			 * @return {void}
			 */
			function share() {

				var data = {
					action: 'llms_sl_new_share',
					nonce: $( '#llms-sl-new-share-nonce' ).val(),
					noun: $( '#llms-sl-new-share-noun' ).val(),
					content: get_content(),
					img_id: $attachments.attr( 'data-image-id' ),
				};

				clear_error( $error );
				post( data, $card, function( r ) {

					if ( ! r ) {
						show_error( $error, LLMS.l10n.translate( 'An unknown error occurred, please try again.' ) );
					} else if ( r && ! r.success ) {
						show_error( $error, r.message );
					} else {
						LLMS.Spinner.start( $card );
						window.location.reload();
					}

				} );

			};

			bind();

		};

		var f = new Filtering(),
		m     = new Managing(),
		p     = new Paging(),
		s     = new Sharing();

		// Initialize Replying for existing stories.
		$( 'form.llms-sl-story-reply' ).each( function() {
			new Replying( $( this ) );
		} );

		donuts();
		images();

	};

	var a = new StoryInteractions();

} )( jQuery );
